import { Button, Modal, type ModalProps } from 'flowbite-react';
import { CoinsIcon } from 'lucide-react';
import { useCallback } from 'react';

export interface CreditConfirmationModalProps extends ModalProps {
    creditCost: number;
    featureName: string;
    onConfirm: () => void;
}

export const CreditConfirmationModal = ({
    show,
    onClose,
    creditCost,
    featureName,
    onConfirm,
}: CreditConfirmationModalProps) => {
    const handleConfirm = useCallback(() => {
        onClose?.();
        onConfirm();
    }, [onClose, onConfirm]);

    const handleCancel = useCallback(() => {
        onClose?.();
    }, [onClose]);

    return (
        <Modal show={show} size="md" onClose={onClose} popup>
            <Modal.Header />
            <Modal.Body>
                <div className="text-center">
                    <div className='flex flex-col items-center gap-4'>
                        <CoinsIcon size={42} className='text-amber-500' />

                        <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-400">
                            Potvrzení nákladů
                        </h3>

                        <p className='text-sm text-gray-700 dark:text-gray-300'>
                            Za použití funkce <strong>{featureName}</strong> bude odečteno <strong>{creditCost} {creditCost === 1 ? 'kredit' : creditCost < 5 ? 'kredity' : 'kreditů'}</strong>.
                        </p>
                    </div>

                    <div className="flex justify-center gap-4 mt-6">
                        <Button
                            color="primary"
                            onClick={handleConfirm}
                        >Potvrdit</Button>
                        <Button
                            color="gray"
                            onClick={handleCancel}
                        >Zrušit</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};
